import { palette } from '$tablet-app/src/app/theme';
import styled from 'styled-components/native';

const Separator = styled.View`
  height: 10px;
  background-color: ${palette.Background_blue};
  border-top-color: ${palette.Outline_blue};
  border-top-width: 1px;
  border-bottom-width: 1px;
  border-bottom-color: ${palette.Outline_blue};
  margin: 10px 0 20px;
`;

export default Separator;
